var path = '/modules/exports/views/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/exports/views/list.tpl.html
// module id = 2097
// module chunks = 1